import Input$1 from './Input.js';
import withForm from '../Form/withForm.js';

var Input = withForm(Input$1);

export { Input as default };
